import { useEffect, useState } from 'react';
import { Panel } from '../../components/ui';
import { getWaitlistSpots } from '../../services/waitlistService';

export function WaitlistState() {
  const [spotsRemaining, setSpotsRemaining] = useState<number | null>(null);

  useEffect(() => {
    let cancelled = false;
    getWaitlistSpots()
      .then((data) => {
        if (!cancelled && typeof data?.remaining === 'number') {
          setSpotsRemaining(data.remaining);
        }
      })
      .catch(() => {
        // Spots count is a nice-to-have; render without it if the request fails.
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-surface px-4">
      <Panel className="relative w-full max-w-md overflow-hidden p-8 text-center">
        <div
          aria-hidden="true"
          className="absolute -top-16 left-1/2 h-40 w-40 -translate-x-1/2 rounded-full bg-accent-gradient opacity-30 blur-3xl animate-pulse"
        />
        <div className="relative flex flex-col items-center gap-3">
          <span
            aria-hidden="true"
            className="h-3 w-3 rounded-full bg-accent-gradient animate-pulse"
          />
          <h1 className="font-sans text-xl font-semibold text-body">You're on the list</h1>
          <p className="text-sm text-muted">
            We're letting people in gradually so every workspace gets the attention it deserves.
            We'll email you the moment your access is approved — no need to keep refreshing.
          </p>
          {spotsRemaining !== null && (
            <p className="text-xs text-faint">{spotsRemaining} spots remaining in this wave</p>
          )}
        </div>
      </Panel>
    </div>
  );
}
